<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_xiv"></a><a id="ill"></a><em>Illustrations</em></p>
<p class="toc-list"><a href="#/html/9780226308128_14_ch3#fig1">1. <em>Basilica</em></a></p>
<p class="toc-list"><span href="#/html/9780226308128_15_ch4#fig2" title="Link target outside of Sample">2. <em>Roman and Byzantine Vault Forms</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_15_ch4#fig3" title="Link target outside of Sample">3. <em>Later Byzantine Vault Forms</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_23_ch11#fig4" title="Link target outside of Sample">4. <em>Romanesque Ground Plans</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_23_ch11#fig5" title="Link target outside of Sample">5. <em>Cross Section of Romanesque Church, Twelfth Century</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_23_ch11#fig6" title="Link target outside of Sample">6. <em>Evolution of Mediaeval Vaulting</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_23_ch11#fig7" title="Link target outside of Sample">7. <em>Structural Framework of Gothic Cathedral, Thirteenth Century</em></span></p>
<p class="toc-list"><span href="#/html/9780226308128_23_ch11#fig8" title="Link target outside of Sample">8. <em>Gothic Vaults, Thirteenth Century</em></span></p>
<p class="toc-listb"><span href="#/html/9780226308128_23_ch11#fig9" title="Link target outside of Sample">9. <em>Ground Plan of Chartres Cathedral</em></span></p>
<p class="h4"><a id="ack"></a>ACKNOWLEDGMENTS</p>
<p class="noindent">Illustrations Nos. 2 and 3 are from Kenneth J. Conant, A BRIEF COMMENTARY ON EARLY MEDIAEVAL ARCHITECTURE. Copyright 1942 by The Johns Hopkins University Press. Reprinted by permission of The Johns Hopkins University Press. No. 5 is from Clarence Ward, MEDIAEVAL CHURCH VAULTING. Copyright 1915 by Princeton University Press. Reprinted by permission of Princeton University Press. No. 6 is from James Westfall Thompson and E.N. Johnson, INTRODUCTION TO MEDIAEVAL EUROPE. Copyright 1937 by W. W. Norton and Company, Inc. Redrawn by permission of W. W. Norton and Company, Inc. No. 8 is from F. Bond, AN INTRODUCTION TO ENGLISH CHURCH ARCHITECTURE (London, Humphrey Milford, 1913). Copyright 1913 by F. Bond. Reprinted by permission of the executors of the F. Bond estate.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226308128_10_ill.vue?7c40a7b6